import axios from 'axios'

import type { Country } from '@/types/types'

const countries = ref<Country[]>([])
const isLoadingCountries = ref(false)
const countriesError = ref<string | null>(null)
let countriesRequest: Promise<Country[]> | null = null

const loadCountries = async (force = false): Promise<Country[]> => {
  if (!force && countries.value.length > 0) {
    return countries.value
  }

  if (countriesRequest) {
    return countriesRequest
  }

  countriesError.value = null
  isLoadingCountries.value = true

  countriesRequest = (async () => {
    try {
      const { data } = await axios.get('/public/countries')
      countries.value = data.data ?? []
    } catch (error) {
      countries.value = []
      countriesError.value = 'fetch_failed'
      console.error('Error while fetching countries:', error)
    } finally {
      isLoadingCountries.value = false
      countriesRequest = null
    }

    return countries.value
  })()

  return countriesRequest
}

export default function useCountries() {
  return {
    countries: readonly(countries),
    countriesError: readonly(countriesError),
    isLoadingCountries: readonly(isLoadingCountries),
    fetchCountries: loadCountries
  }
}
